import { useFormContext } from 'react-hook-form'
import { z } from 'zod'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker } from '@fortem-monorepo/react-ui'
import { SelectInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

import { baseSchema } from '@/components/forms/pricing-interface/schemas'

type BaseSchemaType = z.infer<typeof baseSchema>

export interface BaseFormFieldsProps {}

export const BaseFormFields: React.FC<BaseFormFieldsProps> = ({}) => {
  const { setValue, control, formState, register } = useFormContext<BaseSchemaType>()

  return (
    <div className={'flex flex-col gap-4'}>
      <FormField
        control={control}
        name="structure_name"
        render={() => {
          return (
            <FormItem>
              <FormLabel>Structure Name</FormLabel>
              <Input
                inputSize="sm"
                {...register('structure_name')}
                disabled={formState.isSubmitting}
              />
            </FormItem>
          )
        }}
      />
      <FormField
        control={control}
        name="value_date"
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Value Date</FormLabel>
              <DatePicker
                size={'sm'}
                selected={value ? new Date(value) : undefined}
                buttonDisabled={formState.isSubmitting}
                onSelect={(val) =>
                  val && setValue('value_date', toISO8601(val), { shouldValidate: true })
                }
              />
            </FormItem>
          )
        }}
      />
      <FormField
        control={control}
        name="instance_tag"
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Instance Tag</FormLabel>
              <SelectInput
                size={'sm'}
                disabled={formState.isSubmitting}
                value={value}
                onValueChange={(val) =>
                  setValue('instance_tag', val as 'LOCALINST1' | 'LOCALINST2', {
                    shouldValidate: true,
                  })
                }
                options={['LOCALINST1', 'LOCALINST2'].map((v) => ({
                  label: v,
                  value: v,
                }))}
              />
            </FormItem>
          )
        }}
      />
    </div>
  )
}
